<script setup>
const route = useRoute()
const mapName = route.params.area
if (!areaToPrefTable.some(({ key }) => key === mapName)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('area', getPrefectureName(mapName))
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = getBreadCrumb(mapName)
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :area="areaToPrefTable.find(({ key }) => key === mapName).name"
      :area-roma="mapName"
    >
      <div class="frame">
        <LivecamPrefList
          :area="mapName"
        />
      </div>
      <template #main-bottom>
        <LivecamFeature
          :target-key="mapName"
          :title="`（${areaToPrefTable.find(({ key }) => key === mapName).name}）`"
        />
        <LivecamAreaList />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
